module.exports = __webpack_public_path__ + "assets/svg/UI/position-white-4d67dd.svg";